import React from 'react';
import { useField } from 'formik';
import PropTypes from 'prop-types';

// Components
import Asterisk from '@atoms/Asterisk';
import { ResponsiveBlock, ErrorText, Label, FormLabel, FormInput } from '@styled';

// Helpers
import restrictKeyPressToDigits from '@general/restrictKeyPressToDigits';
import restrictPasteToDigits from '@general/restrictPasteToDigits';

const FundAmountOther = ({ amount, onAmountChange }) => {
    const [field, meta] = useField('amountOther');

    return (
        <fieldset className="mt-1">
            <Label className="mb-3 mb-md-2" htmlFor="amountOther">
                <ResponsiveBlock className="mb-1 mb-md-0">
                    {meta.touched && meta.error ? (
                        <FormLabel>
                            <ErrorText>{meta.error}</ErrorText>
                        </FormLabel>
                    ) : (
                        <FormLabel>
                            Amount Other
                            <Asterisk />
                        </FormLabel>
                    )}
                </ResponsiveBlock>

                <ResponsiveBlock>
                    <FormInput
                        {...field}
                        type="text"
                        id="amountOther"
                        name="amountOther"
                        value={amount}
                        onChange={onAmountChange}
                        onKeyPress={restrictKeyPressToDigits}
                        onPaste={restrictPasteToDigits}
                    />
                </ResponsiveBlock>
            </Label>
        </fieldset>
    );
};

FundAmountOther.propTypes = {
    amount: PropTypes.string,
    onAmountChange: PropTypes.func.isRequired,
};

export default FundAmountOther;
